/**
 * Ticket Features Configuration
 * Defines which features are enabled for the ticket table
 */
export const ticketFeatures = {
  search: true,
  filters: true,
  export: true,
  bulkActions: true,
  columnResizing: true,
  columnVisibility: true,
  savedViews: true,
  infiniteScroll: true,
  multiColumnSort: true,
  calendarView: true,
};
